import {
  getContainerFluxItems,
  getContainerTypeItems,
  getCurrentStatesNormalizedPolygonFromLeafletPolygonData,
  itemsPerPage,
  maxAllowedItems,
  filterContainersBins,
  addressSearchRadius,
  getKeyFromState,
} from '@/services/containers'
import store from '@/store'
import { getCurrentStatesNormalizedPolygonFromLeafletBounds } from '@/services/containers'
import { isTestMode } from '@/services/env-service'
import api from '@/api'
import moment from 'moment'
import i18n from '@/i18n'

/**
 *
 * @returns
 */
function newState() {
  return {
    items: [], //Current states

    stateItemsTotalAvailCount: 0,

    binItems: [], //Bins, Bac reference data
    /**
     * Total items available for client X (ref data count)
     */
    binItemsTotalAvailableClientCount: 0,
    /**
     * Total items available in the API during the last search (bins)
     */
    binItemsTotalAvailableCount: 0,
    /**
     * Tracks  if we are currently fetching more items. Used to prevent multiple requests at once
     */
    binItemsLoadingPromise: null,

    fluxItems: [],
    typeItems: [],
    allBinItems: [],

    loadingPromise: null,

    /**
     * @property {string} containsPolygon - The normalized polygon a string
     */
    containsPolygon: '',
    /**
     * @enum {string}
     * @property {string} mapviewport - Represents the map viewport type.
     * @property {string} pv - Represents the pv type.
     * @property {string} zone - Represents the zone type.
     * @property {string} lasso - Represents the lasso type.
     */
    containsPolygonType: '',
    containsPolygonMapViewport: '',

    zoomLevel: null,

    maxAllowedItems,
    itemsPerPage,

    metricsResult: {},

    referentialReady: false,

    mode: 'planned_today', // planned_today | collected_at

    markersVisibility: {
      collected: true,
      toBeCollected: true,
      notCollected: true,
      notCollectedNotPlaned: true,
      lessThan24h: true,
      between24hAnd48h: true,
      between48hAnd72h: true,
      moreThan72h: true,
      neverCollected: true,
    },

    allBinItemsLoaded: false, //Flag for bins csv export button
    //State items are hardcoded in store since there's no database table to store them for now
    stateItems: [
      {
        id: 0,
        label: i18n.t('container_module.state_label.in_stock'),
      },
      {
        id: 1,
        label: i18n.t('container_module.state_label.in_service'),
      },
      {
        id: 2,
        label: i18n.t('container_module.state_label.out_of_service'),
      },
    ],
  }
}

export default {
  namespaced: true,
  state: newState(),
  getters: {
    filtersAreReady: (state) => state.referentialReady,
    /**
     * Total for client X:
     * + Total from bins API
     * + Total from current_state API when there is no binId (puce sans bac)
     * @param {*} state
     * @returns
     */
    binItemsTotalAvailableClientCount(state) {
      return (
        state.binItemsTotalAvailableClientCount + 0
        //(state.items || []).filter((i) => !i.binId).length
      )
    },
    lastCollectionMetrics: (state) => {
      let less_than_24h = 0
      let between_24h_and_48h = 0
      let between_48h_and_72h = 0
      let more_than_72h = 0
      let never = 0

      const now = moment()
      const items = [...state.items, ...state.binItems]

      for (let item of items) {
        const date = moment(item.collectedAt)

        if (!date.isValid() || item.collectedAt === undefined) {
          never += 1
          continue
        }

        const hoursDifference = now.diff(date, 'hours')

        if (hoursDifference < 24) {
          less_than_24h += 1
        } else if (hoursDifference >= 24 && hoursDifference < 48) {
          between_24h_and_48h += 1
        } else if (hoursDifference >= 48 && hoursDifference < 72) {
          between_48h_and_72h += 1
        } else {
          more_than_72h += 1
        }
      }

      return {
        less_than_24h,
        between_24h_and_48h,
        between_48h_and_72h,
        more_than_72h,
        never,
      }
    },
  },
  actions: {
    setMode({ state }, payload) {
      if (payload === 'collected_at') {
        state.mode = 'collected_at'
      }

      if (payload === 'planned_today') {
        state.mode = 'planned_today'
      }
    },
    resetMarkersVisibility({ state }) {
      Object.assign(state.markersVisibility, {
        collected: true,
        toBeCollected: true,
        notCollected: true,
        notCollectedNotPlaned: true,
        lessThan24h: true,
        between24hAnd48h: true,
        between48hAnd72h: true,
        moreThan72h: true,
        neverCollected: true,
      })
    },
    /**
     *
     * @param {Object} vueContext
     * @param {Object} options
     * @param {Boolean} [options.keepReferenceData] Keep fluxItems and typeItems
     * @param {Array} [options.ignoreArr] Keys to ignore
     */
    resetStore(
      { state },
      { keepReferenceData, ignoreArr, keepMode } = {
        keepReferenceData: true,
        ignoreArr: [],
        keepMode: false,
      }
    ) {
      let newStateVals = newState()

      for (let key in newStateVals) {
        if (
          keepReferenceData &&
          [
            'fluxItems',
            'typeItems',
            'binItemsTotalAvailableClientCount',
            ...ignoreArr,
          ].includes(key)
        ) {
          continue
        }

        if (keepMode && key === 'mode') {
          continue
        }

        state[key] = newStateVals[key]
      }
    },
    resetSearchState({ state }) {
      console.log('containers reset store state')

      //Current state
      state.items = []
      state.stateItemsTotalAvailCount = 0

      //Bins
      state.binItems = []
      state.binItemsTotalAvailableCount = 0
    },
    /**
     *
     * @param {Object} vuexContext
     * @param {Objec} payload binCollectionCurrentStatesIndicators get params
     */
    async updateContainersIndicators({ state }, payload = {}) {
      console.log('updateContainersIndicators')
      let normalizedPayload = {}

      if (
        payload.containsPolygon &&
        (payload.addressLatLng || []).length === 0
      ) {
        normalizedPayload['contains[point]'] = payload.containsPolygon
      }
      if (payload.addressLatLng.length > 0) {
        normalizedPayload['nearPoint[point][longitude]'] =
          payload.addressLatLng[1]
        normalizedPayload['nearPoint[point][latitude]'] =
          payload.addressLatLng[0]
        normalizedPayload['nearPoint[point][radius]'] =
          payload.nearPointRadius > 0
            ? payload.nearPointRadius
            : addressSearchRadius
      }
      if ((payload.containerFluxIds || []).length > 0) {
        normalizedPayload['fluxId'] = payload.containerFluxIds
      }

      if (payload.containerTypeIds.length > 0) {
        normalizedPayload['typeId'] = payload.containerTypeIds
      }

      const filteredPuceNumber = payload.puceNumber.filter(
        (pn) => typeof pn === 'string' && pn.trim().length > 0
      ) // Remove empty strings (case of form with no puceNumber specified)
      if (filteredPuceNumber.length > 0) {
        normalizedPayload['chipNumber'] = filteredPuceNumber // Send only non-empty strings
      }

      if (payload.cuveNumber) {
        normalizedPayload.tankNumber = payload.cuveNumber
      }

      if (payload.containerStateIds?.length > 0) {
        normalizedPayload['binState'] = payload.containerStateIds
      }

      let res = await api.binCollectionCurrentStatesIndicators.getAll(
        normalizedPayload
      )
      state.metricsResult = res
    },
    async updateReferential({ state }) {
      state.referentialReady = false

      console.log('updateReferential')
      if (state.loadingPromise) {
        console.log('updateReferential.wait')
        await state.loadingPromise
      } else {
        state.loadingPromise = (async () => {
          console.log('updateReferential.exec')

          const promises = []

          promises.push(
            getContainerFluxItems().then((fluxItems) => {
              state.fluxItems = fluxItems

              if (state.fluxItems.length === 0 && isTestMode()) {
                state.fluxItems = [
                  { label: 'Flux 100', id: 100 },
                  { label: 'Flux 101', id: 101 },
                ]
              }
            })
          )
          promises.push(
            getContainerTypeItems().then((typeItems) => {
              state.typeItems = typeItems

              if (state.typeItems.length === 0 && isTestMode()) {
                let pictureSVG = `<svg xmlns="http://www.w3.org/2000/svg" width="18.098" height="24.999" viewBox="0 0 18.098 24.999"><path d="M14.459,24A2.64,2.64,0,1,1,17.1,21.359,2.674,2.674,0,0,1,14.459,24Zm0-4.2a1.56,1.56,0,1,0,1.559,1.56A1.593,1.593,0,0,0,14.459,19.8ZM11.52,23.4h0l-5.759,0H5.708a3.142,3.142,0,0,1-2.075-1.174A5.015,5.015,0,0,1,2.159,19.5V10.98A7.851,7.851,0,0,0,.66,7.26V3.782H14.938v14.1a3.251,3.251,0,0,0-.759-.091,3.49,3.49,0,0,0-3.1,2.068,3.255,3.255,0,0,0,.442,3.542Zm3.9-20.46H.36c-.3,0-.36-.12-.36-.3V1.261c0-.251.132-.3.36-.3H4.98L5.04.9V.24c0-.162.1-.24.3-.24h6.48c.179,0,.239.061.239.24V.9c0,.06.061.06.12.06h3.3c.251,0,.3.132.3.36v1.32C15.78,2.94,15.659,2.94,15.419,2.94Z" transform="translate(0.5 0.5)" fill="#0b72b5" stroke="rgba(0,0,0,0)" stroke-miterlimit="10" stroke-width="1"/></svg>`
                state.typeItems = [
                  {
                    label: 'Type 100',
                    id: 100,
                    pictureSVG,
                  },
                  {
                    label: 'Type 101',
                    id: 101,
                    pictureSVG,
                  },
                ]
              }
            })
          )

          promises.push(
            (async () => {
              let res = await api.bins.getAll(
                {
                  itemsPerPage: 1,
                },
                {
                  headers: {
                    Accept: 'application/hal+json',
                  },
                }
              )
              state.binItemsTotalAvailableClientCount = res?.totalItems || 0
              return
            })()
          )

          await Promise.all(promises)

          state.referentialReady = true
        })()
      }
    },
    prepareToFallbackToMapBoundsAsCoordsFilterValue({ dispatch }) {
      dispatch('updateContainsPolygonFilter')
    },
    clearLassoCoordsFilterValue({ dispatch }) {
      dispatch('updateContainsPolygonFilter', {
        containsPolygonType: 'lasso',
        containsPolygonArray: [],
      })
    },
    /**
     * Update contains polygon (Required to filter by coords using API)
     *
     * Modes:
     * set_default Set map bounds as coords filter
     * set_custom Set lasso,pv or zone as coord filters
     * clear: Clear custom coords filter and set_default
     * @internal
     * @param {Object} vuexContext
     * @param {Object} [payload]
     * @param {Array} [payload.containsPolygonArray] Polygon data in Leaflet format (array)
     * @param {String} [payload.containsPolygon] Polygon data in APIV3 format (string)
     * @param {String} [payload.containsPolygonType] mapviewport, pv, zone, lasso
     */
    updateContainsPolygonFilter(
      { state },
      { containsPolygon, containsPolygonArray, containsPolygonType } = {
        containsPolygon: '',
        containsPolygonType: 'mapviewport',
        containsPolygonArray: [],
      }
    ) {
      let hasIncomingValidType = [
        'mapviewport',
        'lasso',
        'pv',
        'zone',
      ].includes(containsPolygonType)
      let hasStateCustomType = ['lasso', 'pv', 'zone'].includes(
        state.containsPolygonType
      )
      let hasIncomingMapViewType = containsPolygonType === 'mapviewport'

      if (!hasIncomingValidType) {
        throw new Error('INVALID_TYPE')
      }

      let mode = ''
      //mode: clear
      if (
        !hasIncomingMapViewType &&
        !containsPolygon &&
        containsPolygonArray.length === 0
      ) {
        mode = 'clear'
      }
      //mode: update default
      if (hasIncomingMapViewType && hasStateCustomType) {
        mode = 'update_default'
      }
      //mode: set (default)
      if (hasIncomingMapViewType && !hasStateCustomType) {
        mode = 'set_default'
      }
      //mode: set (custom)
      if (
        !hasIncomingMapViewType &&
        (!!containsPolygon || containsPolygonArray.length > 0)
      ) {
        mode = 'set_custom'
      }

      if (
        !['update_default', 'set_default', 'set_custom', 'clear'].includes(mode)
      ) {
        throw new Error('INVALID_MODE')
      }

      let mapViewportPolygon = null
      if (store.state.simpliciti_map.mapViewportBounds) {
        mapViewportPolygon = getCurrentStatesNormalizedPolygonFromLeafletBounds(
          store.state.simpliciti_map.mapViewportBounds
        )
        state.containsPolygonMapViewport = mapViewportPolygon
      }

      console.log('updateContainsPolygonFilter', {
        mode,
        containsPolygonType,
      })

      if (mode === 'clear') {
        state.containsPolygonType = 'mapviewport'
        mode = 'set_default'
      }

      if (mode === 'set_default' && !!mapViewportPolygon) {
        state.containsPolygon = mapViewportPolygon
        state.containsPolygonType = 'mapviewport'
      }

      if (mode === 'set_custom') {
        //use provided bounds
        if (containsPolygonArray?.length > 0) {
          state.containsPolygon =
            getCurrentStatesNormalizedPolygonFromLeafletPolygonData(
              containsPolygonArray
            ) || ''
        }

        if (containsPolygon) {
          state.containsPolygon = containsPolygon
        }
        state.containsPolygonType = containsPolygonType
      }
    },
    onModuleExit({ dispatch }) {
      console.log('onModuleExit')
      dispatch('resetStore')
      import(
        /* webpackChunkName "main" */ '@/composables/containers-module'
      ).then((m) => {
        console.log('m', m)
        m.clearFilters()
      })
      import(
        /* webpackChunkName "main" */ '@/composables/leaflet-lasso-selection'
      ).then((lls) => {
        console.log('lls', lls)

        if (lls._selectionPolygonLayer && lls._selectionPolygonLayer.value) {
          lls._selectionPolygonLayer.value.remove()
          lls._selectionPolygonLayer.value = null
        }

        lls._lassoEnabled.value = false
      })
    },
  },
}
